import * as types from './mutation-types'

export const storeCashRegister=({ commit }, payload ) => {
    return new Promise((resolve,reject) => {
        window.axios.post('store/cash/register', payload).then((response) => {
            commit(types.ADD_CASH_REGISTER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })   
}

export const fetchCashRegisters = ({ commit}, shop_id) => {
    return new Promise((resolve, reject) => {
        window.axios.get(`get/cash/registers/collection?shop_id=${shop_id}`).then((response) => {
            commit(types.SET_CASH_REGISTERS, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
})
}

export const updateCashRegister = ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.patch(`update/${data.id}/cash/register`, data).then((response) => {
            commit(types.UPDATE_CASH_REGISTER, response.data.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const deleteCashRegister = ({ commit }, cashRegisterId) => {
    return new Promise((resolve, reject) => {
        window.axios.delete(`delete/${cashRegisterId}/cash/register`).then((response) => {          
            commit(types.DELETE_CASH_REGISTER, cashRegisterId)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })      
    })
}




